module.exports = __webpack_public_path__ + "img/fd83042eebf3e78fd44a54b472d2bdd2.26bb52e4.png";